<div class="row h-100">
  <div class="col scroll-container px-0">
    <div class="card-container d-flex flex-column"
         #card *ngIf="data?.entityType">
      <main class="card-content d-flex flex-column pt-4 pt-laptop-7">
        <app-card-header *ngIf="!useHeaderV2"
                         [data]="entity"
                         [originalData]="data"
                         (getIt$)="getItForRollupCard($event)"
                         (placeHold$)="placeHoldOnRollupCard($event)"
                         (tableInited)="onTableInited()">
        </app-card-header>
        <app-format-group-card-header (getIt$)="getItForRollupCard($event)"
                                      (placeHold$)="placeHoldOnRollupCard($event)"
                                      (tableInited)="onTableInited()"
                                      *ngIf="useHeaderV2"
                                      [formatGroup]="entity">
        </app-format-group-card-header>
        <router-outlet></router-outlet>
      </main>
      <app-universal-footer></app-universal-footer>
    </div>
  </div>
</div>
